import { z } from "zod";
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];
export const RegistrationSchema = z
  .object({
    first_name: z.string().min(2),
    last_name: z.string().min(2),
    role: z.enum(["admin", "supervisor", "agent"], {
      message:
        'Role must be one of the following "admin", "supervisor", "agent"',
    }),
    phone_number: z
      .string()
      .min(1, { message: "Must be a valid mobile number min lenth is 3" })
      .max(14, { message: "Must be a valid mobile number" }),
    gender: z.enum(["ذكر", "انثي"], {
      message: 'Gender must be one of the following "ذكر", "انثي"',
    }),
    birthdate: z.coerce.date(),
    username: z.string().min(3).max(20),
    email: z.string().email(),
    password: z.string().min(4, "Password must be at least 3 characters"),
    password_confirmation: z.string(),
    profile_photo: z
      .any()
      .refine((file) => {
        return file?.size <= MAX_FILE_SIZE, `Max image size is 5MB.`;
      })
      
      .optional(),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords must match",
    path: ["password_confirmation"],
  });

export const LoginSchema = z.object({
  email: z.string().min(4, "Email must be at least 4 characters"),
  password: z.string().min(2, "Password must be at least 2 characters"),
});
export const AddOfferModolSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  description: z.string().optional(),
});

export const AddMemberSchema = z
  .object({
    email: z.string().email(),
    password: z.string().min(6, "Password must be at least 10 characters"),
    profile_photo: z
      .any()
      .refine((file) => {
        return file?.size <= MAX_FILE_SIZE, `Max image size is 5MB.`;
      })
      .refine((file) => {
        return (
          ACCEPTED_IMAGE_TYPES.includes(file?.type),
          "Only .jpg, .jpeg, .png and .webp formats are supported."
        );
      })
      .optional(),
    license_photo: z.any().optional(),
    first_name: z.string().min(3),
    last_name: z.string().min(3),
    job_title_id: z.string().min(1, {
      message: "Gender must be one of the following",
    }),
    joined_at: z.string().optional(),
    password_confirmation: z.string(),
    phone_number: z
      .string()
      .min(1, { message: "Must be a valid mobile number min lenth is 1" })
      .max(14, { message: "Must be a valid mobile number" }),
    birth_date: z.string().min(1, { message: "You have to select Birth Date" }),
    gender: z.string().min(1, {
      message: 'Gender must be one of the following "ذكر", "انثي"',
    }),
    username: z.string().min(4).max(20),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords must match",
    path: ["password_confirmation"],
  });

export const AddMianCatogirySchema = z.object({
  profile_photo: z
    .any()
    .refine((file) => {
      return file?.size <= MAX_FILE_SIZE, `Max image size is 5MB.`;
    })
    .refine((file) => {
      return (
        ACCEPTED_IMAGE_TYPES.includes(file?.type),
        "Only .jpg, .jpeg, .png and .webp formats are supported."
      );
    })
    .optional(),
  description: z.string().min(10),
  name: z.string().min(4),
  background: z.string().min(4).max(7),
});

export const AddMianSubCatogirySchema = z.object({
  profile_photo: z
    .any()
    .refine((file) => {
      return file?.size <= MAX_FILE_SIZE, `Max image size is 5MB.`;
    })
    .refine((file) => {
      return (
        ACCEPTED_IMAGE_TYPES.includes(file?.type),
        "Only .jpg, .jpeg, .png and .webp formats are supported."
      );
    })
    .optional(),
  catogiryType: z.string().min(4),
  description: z.string().min(10),
  name: z.string().min(4),
  background: z.string().min(4).max(7),
});
export const AddNewServesSchema = z.object({
  activation: z.boolean().optional(),
  name: z.string().min(4),
  subCategory: z.string().optional(),
  price: z.string(),
  serviceTime: z.string().min(4),
  offerOnly: z.boolean().optional(),
  isEquipped: z.boolean().optional(),
});

export const addNewItemSchema = z.object({
  itemName: z
    .string()
    .min(3, { message: "Item Name must be at least 3 characters" })
    .max(50, { message: "Item Name cannot exceed 50 characters" }),
  description: z
    .string()
    .min(10, { message: "description must be at least 10 characters" })
    .max(50, { message: "Item Name cannot exceed 50 characters" }),
  category: z.string().min(3, { message: "Unit is required" }),
  unit: z.string().min(1, { message: "Unit is required" }),
  status: z.string().min(1, { message: "Status is required" }),
  brand: z.string().min(1, { message: "Brand is required" }),
});
